<template>
	<div v-loading='loading'>
		<div class="bg-fff more-list list">
			<el-row :gutter="25" class="container">
				<el-col>
					<div class="nav-btn">
						<router-link v-for="(item,index) in navList"
							:class="item.title==current ? 'nav-btn-active' : ''"
							:to="`/news?id=${item.id}&name=${item.title}`">{{item.title}}</router-link>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="5" :lg="5" :xl="5" v-if="list&&list.length>0"
					v-for="(item, index) in list" :key="index" class="list-list product-item">
					<router-link :to="`/newsdetail?id=${item.id}`">
						<div class="item-box ">
							<div class="tc icon-img ">
								<img :src="item.cover" v-if="item.cover">
							</div>
							<h3 class="title-txt">{{ item.title }}</h3>
						</div>
					</router-link>
				</el-col>
			</el-row>
		</div>
		<el-col class="btm-btn" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
			<div @click="change('index')">首页</div>
			<div @click="change('desc')">前一页</div>
			<div @click="change('add')">后一页</div>
		</el-col>
	</div>
</template>
<script>
	import 'bootstrap/dist/js/bootstrap.js'
	import 'bootstrap/dist/css/bootstrap.min.css'
	import 'bootstrap/dist/js/bootstrap.min'
	import moment from '@/utils/moment';
	import {
		Adv
	} from '@/api/adv';
	var adv = new Adv();
	export default {
		data() {
			return {
				loading: false,
				current: '规则',
				id: '',
				navList: [],
				page: 1,
				per_page: 10,
				list: []
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.current = this.$route.query.name;
			this.loading = true;
			this.getNavBar();
			this.getList();
		},
		filters: {
			// 时间格式化
			time(val) {
				return moment(val * 1000).format('YYYY-MM-DD HH:mm');
			},
		},
		watch: {
			$route(to, from) {
				if (to.query.id != from.query.id) {
					this.list = [];
					this.id = to.query.id;
					this.current = to.query.name;
					this.getList();
				}
			}
		},
		methods: {
			//
			getNavBar() {
				var that = this;
				var param = {};
				adv.navbar(param).then(data => {
					that.navList = that.navList.concat(data.data);
				}).catch((res) => {});
			},
			//分类
			getList() {
				var that = this;
				var param = {
					'per-page': this.per_page,
					page: this.page,
					navbar_item_id: this.id
				};
				this.loading = false;
				adv.navList(param).then(data => {
					that.list = data.data;
				}).catch((res) => {});
			},
			change(type) {
				if (type == 'desc') {
					if (this.page == 1) {
						this.$message({
							message: '已是第一页',
							type: 'warning'
						});
					} else {
						this.list = [];
						this.page--;
						this.getList();
					}
				} else if(type == 'add') {
					this.list = [];
					this.page++;
					this.getList();
				}else if(type == 'index'){
					this.list = [];
					this.page=1;
					this.getList();
				}
			}
		}
	};
</script>
<style scoped>
	#app {
		font-size: 14px;
		background-color: #fff;
		color: #333;
	}

	.carousel-banner {
		height: 400px;
	}

	.carousel-banner el-carousel-item,
	.carousel-banner-item {
		height: 100%;
	}

	.carousel-banner .carousel-banner-item image {
		height: 100%;
	}

	a {
		color: #333;
	}

	.theme-color {
		color: #20b483;
	}

	.price-txt {
		color: #20b483 !important;
		font-weight: normal !important;
	}

	.icon-31gouwuche {
		background-color: unset !important;
		color: #20b483 !important;
		font-size: 20px;
		/* width: 30px;
		height: 30px;
		border-radius: 50%; */
	}

	.bg-fa {
		background-color: #fafafa;
	}

	.fs-14 {
		font-size: 14px;
	}

	.fs-16 {
		font-size: 16px;
	}

	.fs-18 {
		font-size: 18px;
	}

	.fs-32 {
		font-size: 32px;
	}

	h1 {
		font-size: 28px;
		text-align: center;
		width: 100%;
		padding: 20px 0;
	}

	h2 {
		font-size: 24px;
		text-align: center;
		width: 100%;
		padding: 20px 0;
	}

	h3 {
		font-size: 18px;
		text-align: center;
		width: 100%;
		padding: 20px 0;
	}

	.container,
	.container-fluid,
	.container-xxl,
	.container-xl,
	.container-lg,
	.container-md,
	.container-sm {
		margin-left: auto !important;
		margin-right: auto !important;
	}

	.el-header {
		background-color: #fff !important;
		color: #333;
		line-height: 60px;
		height: auto !important;
	}

	.top-login-box {
		height: auto !important;
		background-color: #f1f1f1 !important;
		padding: 0 10% !important;
		line-height: 40px !important;
		color: #666;
	}

	.website-log-box {
		padding: 20px 0 !important;

		&-item {
			display: flex;
			align-items: center;
		}
	}

	.website-log-box-right {
		display: flex;
		align-items: center;
	}

	.website-name {
		font-size: 36px;
		color: #2c3096;
		font-weight: bold;
	}

	.search-input {
		border-radius: 0;
		height: 50px !important;
		line-height: 50px !important;
		padding: 0 5px;
		border: 1px solid #eee;
		width: 100%;
		border-radius: unset
	}

	el-input,
	input {
		padding-right: 30px;
		line-height: 50px !important;
		height: 50px !important;
	}

	.el-button--success {
		color: #FFF;
		background-color: #20b483;
		border-color: #20b483;
		height: 50px;
		border-radius: 0;
	}

	.nav-list .el-menu--horizontal>.el-menu-item {
		cursor: pointer;
		font-size: 16px;
	}

	.nav-list {
		padding: 20px 0 !important;
	}

	.el-menu.el-menu--horizontal {
		display: flex;
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: none !important;
		color: #20b483;
		padding: 0 40px;
		font-size: 16px;
	}

	.el-pagination {
		margin: 20px 0 !important;
	}

	.el-dropdown-link,
	.el-dropdown-link-item {
		font-size: 16px;
		cursor: pointer;
	}

	.el-dropdown-link-active {
		color: #2c3096;
	}

	/* 轮播图 */
	.el-carousel__container {
		position: relative;
		height: 400px;
	}

	.el-carousel__item el-image {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 400px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	.demo-image__lazy {
		height: 400px;
		overflow-y: auto;
	}

	.demo-image__lazy {
		height: 400px;
		overflow-y: auto;
	}

	.demo-image__lazy .el-image {
		display: block;
		min-height: 200px;
		margin-bottom: 10px;
		width: 100%;
	}

	.el-image {
		position: relative;
		display: inline-block;
		overflow: hidden;
		height: 100%;
		width: 100%;
	}

	/* 轮播图end */
	/* 精选商品 */
	p {
		color: #666;
		text-align: center;
		font-size: 16px;
	}


	.h1,
	.h2,
	.h3,
	.h4,
	.h5,
	.h6,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-family: inherit;
		font-weight: 500;
		line-height: 1.1;
		color: inherit;
	}

	.product-bottom-price-box {
		position: absolute;
		bottom: 0;
	}

	.product-price-box {
		margin-top: 20px;
		/* color: #20b483; */
		color: #ff0000;
		font-size: 22px;
	}


	/*  */
	.more-list {
		padding: 30px 0;
	}

	.more-list .product-item {
		margin: 10px 0.5%;
		height: 105px !important;
	}

	.more-list-title {
		display: flex;
		align-items: center;
	}

	.more-list-title h1 {
		text-align: left;
		font-size: 24px;
		margin-top: 4px;
		margin-left: -6px;
		margin-right: 4px;
		width: auto !important;
	}

	.more-list-title .iconfont {
		font-size: 32px;
		color: #20b483;
	}

	.more-list-title-lable {
		color: #999;
	}

	.item-box {
		text-align: center;
		background-color: #fff;
	}

	.item-box .tc img {
		height: 72px !important;
		width: 100% !important;
	}

	.item-box h3 {
		font-size: 14px;
		font-weight: 500;
		color: #333333;
		margin: 10px 0 !important;
		padding: 0 10px;
		line-height: 20px;
		height: 20px;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.item-box .width-100 {
		padding: 0 10px;
	}

	.title-txt {
		text-align: center;
	}

	a {
		text-decoration: none !important;
	}

	.cart-img {
		width: 25px;
		height: 25px;
	}

	.text-left {
		display: flex;
		justify-content: space-between;
	}

	/* end */
	/* 底部 */
	.assure-box {
		display: flex;
		align-items: center;
		padding: 30px 0;
		color: #333;
	}

	.assure-item {
		display: flex;
		align-items: center;
	}

	.assure-box .assure-title {
		font-size: 18px;
	}

	.assure-box .assure-dec {
		color: #999;
	}

	.assure-box .assure-item img {
		width: 60px;
		height: 60px;
		margin-right: 10px;
	}

	.box {
		padding: 30px 0;
	}

	ol,
	ul {
		padding-left: 0;
	}

	li {
		list-style: none;
	}

	footer .tit {
		font-size: 18px;
		color: #666;
		line-height: 38px;
		margin-bottom: 20px;
	}

	footer a {
		font-size: 14px;
		line-height: 28px;
		color: #AAAAAA;
	}

	.saoma {
		font-size: 12px;
		margin-left: 5px;
	}

	/* end */
	.el-aside {
		color: #333;
	}

	/* 修改布局 */
	.list .el-col-lg-5,
	.new-product .el-col-lg-5,
	.is-more-pro .el-col-lg-5 {
		width: 19%;
	}

	.new-product .product-item {
		background-color: #fff;
		border: none;
	}

	.nav-btn {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.nav-btn a {
		color: #2c3096;
		font-size: 14px;
		line-height: 35px;
		padding: 0 12px;
		display: block;
		border: 1px solid #2c3096;
		border-radius: 5px;
		margin: 0 4px 8px;
		cursor: pointer;
	}
	.nav-btn-active{
		background: #2c3096;
		color: #fff !important;
	}

	.btm-btn {
		display: flex;
		justify-content: space-around;
		margin-bottom: 20px;
		align-items: center;
	}

	.btm-btn div {
		padding: 0 15px;
		height: 30px;
		border: 1px solid #e4e4e4;
		line-height: 30px;
		background: #fff;
		color: #666666;
		font-size: 13px;
		border-radius: 4px;
	}

	/* 响应式 */
	@media only screen and (min-width: 1600px) {}

	@media only screen and (max-width: 1600px) {}

	@media only screen and (max-width: 1200px) {
		.list .el-col-lg-5 {
			width: 19%;
		}
	}

	@media only screen and (max-width: 992px) {
		.product-bottom-price-box {
			position: relative !important;
		}
	}

	@media only screen and (max-width: 767px) {

		.list-list,
		.product-item {
			width: 49% !important;
		}

		.nav-item img {
			width: 40px;
			height: 40px;
			margin-right: 2px;
		}

		.nav-item .iconfont {
			font-size: 24px;
		}

		.nav-lable {
			font-size: 12px;
		}

		.nav-english {
			display: none;
		}

		.product-bottom-price-box {
			position: relative;

		}

		.item-box h3 {
			height: 20px;
		}

		h1 {
			font-size: 20px;
		}

		.jx-product-namem {
			font-size: 16px;
		}

		.fs-18 {
			font-size: 16px;
		}

		.fs-32 {
			font-size: 28px;
		}

		.el-image__inner {
			border-radius: 4px;
		}

		.el-carousel,
		.el-carousel--horizontal,
		.el-carousel__container {
			height: 200px !important;
		}

		.el-carousel__container,
		.el-carousel__item,
		.el-carousel__mask {
			height: 200px !important;
		}

		footer .tit {
			text-align: center;
		}

		footer ul li {
			text-align: center;
		}


	}

	/* end */
</style>